export default __webpack_public_path__ + "static/media/LolChampionGalleryImg_3.b661b76d.webp";